import { useEffect, useState } from "react";

export const useFetchItemPropertyOverrides = (sku) => {
    const [itemPropertyOverrides, setItemPropertyOverrides] = useState([]);

    useEffect(() => {
        if (!sku) {
            setItemPropertyOverrides([]);
            return;
        }
        const fetchItemPropertyOverrides = async () => {
            try {
                const rsp = await fetch(`api/itemPropertyOverrides/${sku}`);
                if (!rsp.ok) {
                    console.error(`itemPropertyOverrides ${sku} failed: ${rsp.status}`);
                    setItemPropertyOverrides([]);
                    return;
                }
                setItemPropertyOverrides(await rsp.json());
            } catch (e) {
                console.error(`itemPropertyOverrides ${sku}:`, e);
                setItemPropertyOverrides([]);
            }
        };
        fetchItemPropertyOverrides();
    }, [sku]);

    return itemPropertyOverrides;
};

export const PutItemPropertyOverride = async (sku, salesGeographyLevelId, salesGeographyId, inMarketDate, divisionId, regionId, endInMarketDate = null) => {
    const payload = {
        salesGeographyLevelId: salesGeographyLevelId,
        salesGeographyId: salesGeographyId,
        inMarketDate: inMarketDate,
        endInMarketDate: endInMarketDate ?? null,
        divisionId: divisionId ?? null,
        regionId: regionId ?? null
    };

    const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
    };

    const response = await fetch(`api/itemPropertyOverrides/${sku}`, requestOptions);
    return response.ok;
};

export const DeleteItemPropertyOverride = async (sku, salesGeographyLevelId, salesGeographyId) => {
    const requestOptions = { method: "DELETE" };
    const response = await fetch(`api/itemPropertyOverrides/${sku}/${salesGeographyLevelId}/${salesGeographyId}`, requestOptions);
    return response.ok;
};
